/* tslint:disable */
/* eslint-disable */
export enum StorageType {
  FILE_SYSTEM = 0,
  S3 = 1
}
